import styled from 'styled-components';
import iconCrown from '@assets/images/icon/crown.png';
import iconBadge from '@assets/images/icon/icon-medal.png';
import { classic } from '~/themes';
import { useLingui } from '@lingui/react';
import { SSpanTitleSmall } from '~/components/styles/styles';

type IProps = {
  onClick: () => void;
  type: 'crown' | 'badge';
};

type TProps = IProps;

export function Crown({ onClick, type }: TProps) {
  const { i18n } = useLingui();

  return (
    <Container onClick={onClick}>
      <SDivWrapper>
        <SSpan>{`+1`}</SSpan>
        <SDivCrown>
          {type === 'badge' ? (
            <img src={iconBadge} alt="" />
          ) : (
            <img src={iconCrown} alt="" />
          )}
        </SDivCrown>
        <SDivAdvice>
          <SSpanTitleSmall $color={classic.token?.colorWhite}>
            {i18n._('battle.crown.advice')}
          </SSpanTitleSmall>
        </SDivAdvice>
      </SDivWrapper>
    </Container>
  );
}

const Container = styled.div<{ disabled?: boolean }>`
  align-items: center;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
  user-select: none;
  height: 100%;
  width: 100%;
  position: relative;
`;

const SDivAdvice = styled.div`
  position: absolute;
  bottom: 20px;
  width: 70%;
  @media screen and (max-width: 450px) {
    bottom: 40px;
  }

  @media screen and (max-height: 450px) {
    bottom: 0;
  }
`;

const SDivWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  position: relative;
  height: 80%;
  width: 100%;
`;

const SDivCrown = styled.div`
  height: 135px;
  width: 150px;
  position: relative;
  margin-left: 40px;

  img {
    position: absolute;
    top: 0;
    left: 0;
    object-fit: contain;
    height: 100%;
    width: 100%;
  }
  @media screen and (max-height: 600px) {
    height: 90px;
    width: 100px;
  }
  @media screen and (max-width: 450px) {
    height: 90px;
    width: 100px;
    margin-left: 30px;
  }
`;

const SSpan = styled.span<{
  $color?: string;
  $align?: string;
}>`
  color: #2dbf70;
  text-shadow: 0px 10.124px 10.124px rgba(0, 0, 0, 0.25);
  -webkit-text-stroke-width: 7px;
  -webkit-text-stroke-color: #fff;

  font-style: normal;
  font-family: 'Riffic Free', sans-serif;
  font-weight: 700;
  font-size: 9rem;

  text-align: ${({ $align }) => ($align ? $align : 'center')};
  user-select: none;
  @media screen and (max-height: 450px) {
    font-size: 5rem;
  }
  @media screen and (max-width: 450px) {
    font-size: 5rem;
  }
`;

export const SPFeedback = styled.p<{
  $color?: string;
  $align?: string;
}>`
  color: ${classic.token?.colorText};
  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  -webkit-text-stroke-width: 0.8px;
  -webkit-text-stroke-color: #fff;

  font-family: 'Riffic Free', sans-serif;
  font-weight: 700;
  font-size: 1.2rem;
  margin: 10px 0 20px 0;
  text-align: ${({ $align }) => ($align ? $align : 'center')};
  user-select: none;
  @media screen and (max-height: 450px) {
    margin-bottom: 10px;
    font-size: 1rem;
  }
  @media screen and (max-width: 450px) {
    font-size: 1rem;
  }
`;
